import { createSelector } from "@reduxjs/toolkit";

import { integrationsApi } from "@api/integrations";
import type { RootState } from "../../store";

const selectCRMIntegrations = (state: RootState) =>
  integrationsApi.endpoints.getCRMIntegrations.select({})(state);

export const getIntegrationVars = createSelector(
  selectCRMIntegrations,
  (integrationQuery) => {
    const integrationsVariables = integrationQuery.data || [];

    let activeIntegrationVariables = [];

    if (integrationsVariables && integrationsVariables.length) {
      activeIntegrationVariables = integrationsVariables
        .filter((i: any) => i.active)
        .map((i: any) => i.metadata.variables)
        .flat(Number.POSITIVE_INFINITY);
    }

    return activeIntegrationVariables;
  },
);
